import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { searchCPVComponent } from './searchCPV.component';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DirectivesModule } from '../../directives/directives.module';
import { A11yModule } from '@angular/cdk/a11y';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TreeModule } from 'primeng-lts/tree';


@NgModule({
  declarations: [searchCPVComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    TreeModule,
    DynamicDialogModule,
    DirectivesModule,
    A11yModule,
    ScrollPanelModule
  ],
  exports: [searchCPVComponent, DirectivesModule]
})
export class searchCPVModule { }
